import {BaseIdQuery} from "../../models/base.query";
import {IdTextModel, IWithDisplayName} from "../../models/base-id.model";

export class UserQuery extends BaseIdQuery implements IWithDisplayName {
  Email: string;
  Privileges: string[];
  Language: IdTextModel;
  LanguageId: string;
  Fullname: string;
  IsDeleted: boolean;

  get DisplayName(): string {
    return this.Fullname || this.Email;
  }
}
